import { map, isEmpty } from "lodash";
import { isTagRouteActive } from "src/util/tagRouteActive";

const buildNode = ({
  id,
  name,
  toggled,
  disabled,
  active = false,
  children = [],
  ...rest
}) => ({
  id,
  name,
  toggled,
  disabled,
  active,
  children,
  ...rest,
});

const getChildren = ({
  nodeId,
  tags,
  activeTagId,
  tagTypesConfig,
  sectionTagTypeId,
  childrenLoaded,
  toggledNodes,
}) => {
  if (!nodeId) {
    return [];
  }

  const children = [];

  const childrenData = map(tags[nodeId]?.tags || [], (tag) => {
    const childrenLoadedData =
      (childrenLoaded[tag.id] &&
        getChildren({
          nodeId: tag.id,
          tags,
          activeTagId,
          tagTypesConfig,
          sectionTagTypeId,
          childrenLoaded,
          toggledNodes,
        })) ||
      [];

    const routeNode = {
      id: tag.id,
      name: tag.displayValue,
      tagValue: tag,
      type: tag.type,
    };

    const childNode = buildNode({
      ...routeNode,
      active: isTagRouteActive(
        routeNode,
        activeTagId,
        tagTypesConfig,
        sectionTagTypeId
      ),
      toggled: toggledNodes[tag.id] || false,
      disabled: childrenLoaded[tag.id] && childrenLoadedData.length === 0,
      children: childrenLoadedData,
    });

    return childNode;
  });

  children.push(...childrenData);
  return childrenLoaded[nodeId] && isEmpty(childrenData) ? [] : children;
};

const buildTagTypeTree = ({
  nodeId,
  tags,
  activeTagId,
  tagTypesConfig,
  node,
  childrenLoaded,
  toggledNodes,
}) => {
  if (!nodeId) {
    return [];
  }

  const nodeName = tags[nodeId]?.name || node?.name || nodeId;

  const children =
    (childrenLoaded[nodeId] &&
      getChildren({
        nodeId,
        tags,
        activeTagId,
        tagTypesConfig,
        sectionTagTypeId: nodeId,
        childrenLoaded,
        toggledNodes,
      })) ||
    [];

  const routeRoot = { id: nodeId, name: nodeName, isTagType: true };

  const treeData = buildNode({
    ...routeRoot,
    active: isTagRouteActive(routeRoot, activeTagId, tagTypesConfig, nodeId),
    toggled: toggledNodes[nodeId],
    disabled: childrenLoaded[nodeId] && children.length === 0,
    children: childrenLoaded[nodeId] ? children : [],
  });

  return [treeData];
};

export default buildTagTypeTree;
